var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.743 10.331L10.743 0.330996C10.364 -0.0910041 9.63598 -0.0910041 9.25698 0.330996L0.256984 10.331C0.12744 10.4746 0.0424085 10.6527 0.0122281 10.8438C-0.0179524 11.0348 0.00801875 11.2305 0.0869837 11.407C0.246984 11.768 0.604984 12 0.999984 12H2.99998V19C2.99998 19.2652 3.10534 19.5196 3.29288 19.7071C3.48041 19.8946 3.73477 20 3.99998 20H6.99998C7.2652 20 7.51955 19.8946 7.70709 19.7071C7.89463 19.5196 7.99998 19.2652 7.99998 19V15H12V19C12 19.2652 12.1053 19.5196 12.2929 19.7071C12.4804 19.8946 12.7348 20 13 20H16C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V12H19C19.1937 12.0008 19.3834 11.9453 19.546 11.8401C19.7087 11.735 19.8372 11.5848 19.916 11.4079C19.9947 11.231 20.0203 11.0349 19.9896 10.8437C19.9589 10.6525 19.8732 10.4744 19.743 10.331Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.a3852925c2ec8f57f1529ca8ef9b7325.svg";
export { ForwardRef as ReactComponent };